
export default function Support() {
  const supportOptions = [
    {
      icon: 'ri-mail-line',
      title: 'Email Support',
      contact: 'support@frigoaveriobrancoltda.com',
      availability: 'Response within 24 hours'
    },
    {
      icon: 'ri-phone-line',
      title: 'Phone Support',
      contact: '+1 785-599-7188',
      availability: 'Available 24/7'
    },
    {
      icon: 'ri-book-open-line',
      title: 'Help Center',
      contact: 'Browse FAQs & Guides',
      availability: 'Instant answers'
    }
  ];

  return (
    <section id="support" className="py-32 bg-gradient-to-b from-white via-blue-50/30 to-white">
      <div className="max-w-5xl mx-auto px-8 text-center">
        <p className="text-sm text-gray-500 uppercase tracking-wide mb-5 whitespace-nowrap">WE&apos;RE HERE TO HELP</p>
        
        <h2 className="text-5xl font-extrabold text-black leading-tight mb-8">
          24/7 Customer Support<br />
          At Your Service
        </h2>
        
        <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto mb-20">
          Our dedicated support team is always ready to assist you with any questions or technical issues
        </p>

        <div className="grid grid-cols-3 gap-12">
          {supportOptions.map((option, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-10 text-center hover:shadow-lg transition-shadow"
            >
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-6">
                <i className={`${option.icon} text-5xl text-cyan-400`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-black mb-4 whitespace-nowrap">{option.title}</h3>
              
              <p className="text-base text-gray-700 mb-5 break-words">
                {option.contact}
              </p>
              
              <p className="text-sm text-gray-500 whitespace-nowrap">{option.availability}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
